<template>
  <div class="mobile_view">
    <div class="right-content">
      <quiz-overview></quiz-overview>
    </div>
    <div class="left-content">
      <div class="foundation-header">
        <h2>Foundational Screening</h2>
        <h4>As a <i>{{ getGender }}</i> of
          <i>{{ getAge }}</i> of age the following will be included as a baseline health screening:</h4>
      </div>

      <div class="quiz-content">
        <table style="width:100%">
          <tr>
            <th>Included</th>
            <th style="text-transform: capitalize;">{{ `${getGender} (${getAge})` }}</th>
          </tr>
          <tr>
            <td>Medical History and Discussion</td>
            <td>{{ getFoundationalData.header }}</td>
          </tr>
          <tr v-for="(optionData, index) in getFoundationalData.option" :key="index">
            <td v-if="getGender === 'male'">{{ maletable[ index ] }}</td>
            <td v-if="getGender === 'female'">{{ femaletable[ index ] }}</td>
            <td v-if="optionData === 1">Yes</td>
            <td v-if="optionData === 0">No</td>
            <td v-if="optionData === 2">Recommended, not included</td>
            <td v-if="optionData !== 0 && optionData !== 1 && optionData !== 2">
              <button class="w-btn us-btn-style_1" @click="alertDisplay(optionData)">
                <span class="w-btn-label">{{ optionData }}</span>
              </button>
            </td>
          </tr>
          <tr>
            <td>Foundational Screening Cost</td>
            <td>${{ getFoundationalData.cost }}</td>
          </tr>
        </table>
      </div>
      <div class="button-content">
        <button class='btn-prev w-btn us-btn-style_2' @click="prevQuiz">
          <span class="w-btn-label">&larr; Prev</span>
        </button>
        <button class='btn-next btn-active w-btn us-btn-style_1' @click="nextQuiz">
          <span class="w-btn-label">Next &rarr;</span>
        </button>
      </div>
    </div>

  </div>
</template>

<script>

import { mapMutations, mapGetters } from 'vuex';
import foundationalData from "../data/foundational-data.json";
import QuizOverview from './QuizOverview.vue';
import Swal from 'sweetalert2';

export default {
  name: 'QuizFoundationalScreen',

  components: { QuizOverview },

  computed: {
    ...mapGetters( [
      'getAge',
      'getGender',
    ] ),

    maletable() {
      return [
        "Routine Vaccination Discussion",
        "Cardiovascular Examination",
        "Respiratory Examination",
        "Musculoskeletal Examination",
        "Abdominal Examination",
        "ENT Examination",
        "Genital Examination",
        "Clinical Measurements",
        "Blood Tests",
        "Stool Tests",
        "PSA (Prostate)",
      ];
    },
    femaletable() {
      return [
        "Routine Vaccination Discussion",
        "Cardiovascular Examination",
        "Respiratory Examination",
        "Breast Examination",
        "Musculoskeletal Examination",
        "Abdominal Examination",
        "ENT Examination",
        "Genital Examination",
        "Clinical Measurements",
        "Blood Tests",
        "Stool Tests",
        "Mammogram Screening",
      ];
    },

    getFoundationalData() {
      return foundationalData[ this.getGender ][ this.getAge ];
    },
  },

  methods: {
    ...mapMutations( [
      'setStep',
      'setGender',
      'setCostInputed',
    ] ),

    nextQuiz() {
      this.setCostInputed( 3 );
      this.setStep( 3 );
      const $form = document.getElementById( 'form' );
      $form.scrollIntoView();
    },

    prevQuiz() {
      this.setStep( 1 );
      const $form = document.getElementById( 'form' );
      $form.scrollIntoView();
    },
    alertDisplay( level ) {
      var title_string = '<strong><h5>' + this.getGender + " " + this.getAge + '</h5>' + level + '</strong>';
      var html_string;
      if ( level == "Basic" ) {
        html_string = '<p>' +
            '<table style="width:100%;font-size:12px;">' +
            '<tr>' +
            '<td style="border:1px solid #000;padding:5px;">Haematology Profile</td><td style="border:1px solid #000;padding:5px;">Full Blood Count</td>' +
            '</tr><tr>' +
            '<td style="border:1px solid #000;padding:5px;vertical-align: middle;" rowspan="2">Diabetic Panel</td><td style="border:1px solid #000;padding:5px;">HBA1C </td>' +
            '</tr><tr><td style="border:1px solid #000;padding:5px;">Glucose</td>' +
            '</tr><tr><td style="border:1px solid #000;padding:5px;vertical-align: middle;" rowspan="4">Coronary Risk/Cardiac Profile</td><td style="border:1px solid #000;padding:5px;">Total Cholesterol </td>' + '</tr><tr><td style="border:1px solid #000;padding:5px;">Triglycerides</td></tr><tr><td style="border:1px solid #000;padding:5px;">HDL, LDL Cholesterol</td></tr><tr><td style="border:1px solid #000;padding:5px;">Chol/HDL Ratio</td></tr></table></p>';
      }
      if ( level == "Enhanced" ) {
        html_string = '<p><table style="width:100%;font-size:12px;">' +
            '<tr><td style="border:1px solid #000;padding:5px;vertical-align: middle;" rowspan="4">Haematology Profile</td><td style="border:1px solid #000;padding:5px;">Full Blood Count</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Peripheral Blood Film (PBF)</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">ESR</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">ABO Grouping</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;vertical-align: middle;" rowspan="2">Diabetic Panel</td><td style="border:1px solid #000;padding:5px;">HBA1C</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Glucose</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;vertical-align: middle;" rowspan="7">Renal Function (Kidney Function)</td><td style="border:1px solid #000;padding:5px;">Urea</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Creatinine</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Sodium</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Potassium</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Chloride</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Bicarbonate</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">eGFR</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;vertical-align: middle;" rowspan="3">Bone & Joint Profile</td><td style="border:1px solid #000;padding:5px;">Calcium</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Phosphate</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Uric Acid</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;vertical-align: middle;" rowspan="4">Coronary Risk/Cardiac Profile</td><td style="border:1px solid #000;padding:5px;">Total Cholesterol</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Triglycerides</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">HDL, LDL Cholesterol</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Chol/HDL Ratio</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;vertical-align: middle;" rowspan="8">Liver Profile</td><td style="border:1px solid #000;padding:5px;">Total Protein</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Albumin</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Globulin</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Total Bilirubin</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Alkaline Phosphatase</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">SGOT (AST)</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">SGPT (ALT)</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">GGT</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;vertical-align: middle;" rowspan="2">Thyroid Profile</td><td style="border:1px solid #000;padding:5px;">FT4</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">TSH</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;vertical-align: middle;">Urine & Stool Analysis</td><td style="border:1px solid #000;padding:5px;">Urine FEME</td></tr>' +
            '</table></p>';
      }
      if ( level == "Extensive" && this.getGender == 'female' ) {
        html_string = '<p><table style="width:100%;font-size:12px;">' +
            '<tr><td style="border:1px solid #000;padding:5px;vertical-align: middle;" rowspan="4">Haematology Profile</td><td style="border:1px solid #000;padding:5px;">Full Blood Count</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Peripheral Blood Film (PBF)</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">ESR</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">ABO Grouping</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;vertical-align: middle;" rowspan="2">Diabetic Panel</td><td style="border:1px solid #000;padding:5px;">HBA1C</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Glucose</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;vertical-align: middle;" rowspan="7">Renal Function (Kidney Function)</td><td style="border:1px solid #000;padding:5px;">Urea</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Creatinine</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Sodium</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Potassium</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Chloride</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Bicarbonate</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">eGFR</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;vertical-align: middle;" rowspan="3">Bone & Joint Profile</td><td style="border:1px solid #000;padding:5px;">Calcium</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Phosphate</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Uric Acid</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;vertical-align: middle;" rowspan="4">Coronary Risk/Cardiac Profile</td><td style="border:1px solid #000;padding:5px;">Total Cholesterol</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Triglycerides</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">HDL, LDL Cholesterol</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Chol/HDL Ratio</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;vertical-align: middle;" rowspan="8">Liver Profile</td><td style="border:1px solid #000;padding:5px;">Total Protein</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Albumin</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Globulin</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Total Bilirubin</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Alkaline Phosphatase</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">SGOT (AST)</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">SGPT (ALT)</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">GGT</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;vertical-align: middle;" rowspan="2">Thyroid Profile</td><td style="border:1px solid #000;padding:5px;">FT4</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">TSH</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;vertical-align: middle;" rowspan="3">Urine & Stool Analysis</td><td style="border:1px solid #000;padding:5px;">Urine FEME</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Urine Microalbumin / Creatinine Ratio</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Stool Occult Blood (Immuno)</td></tr>' +
            '</table></p>';
      }
      if ( level == "Extensive" && this.getGender == "male" ) {
        html_string = '<p><table style="width:100%;font-size:12px;">' +
            '<tr><td style="border:1px solid #000;padding:5px;vertical-align: middle;" rowspan="2">Haematology Profile</td><td style="border:1px solid #000;padding:5px;">Full Blood Count</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Peripheral Blood Film (PBF)</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;vertical-align: middle;" rowspan="2">Diabetic Panel</td><td style="border:1px solid #000;padding:5px;">HBA1C</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Glucose</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;vertical-align: middle;" rowspan="7">Renal Function (Kidney Function)</td><td style="border:1px solid #000;padding:5px;">Urea</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Creatinine</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Sodium</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Potassium</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Chloride</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Bicarbonate</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">eGFR</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;vertical-align: middle;">Bone & Joint Profile</td><td style="border:1px solid #000;padding:5px;">Uric Acid</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;vertical-align: middle;" rowspan="4">Coronary Risk/Cardiac Profile</td><td style="border:1px solid #000;padding:5px;">Total Cholesterol</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Triglycerides</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">HDL, LDL Cholesterol</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Chol/HDL Ratio</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;vertical-align: middle;" rowspan="8">Liver Profile</td><td style="border:1px solid #000;padding:5px;">Total Protein</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Albumin</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Globulin</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Total Bilirubin</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Alkaline Phosphatase</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">SGOT (AST)</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">SGPT (ALT)</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">GGT</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;vertical-align: middle;" rowspan="2">Thyroid Profile</td><td style="border:1px solid #000;padding:5px;">FT4</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">TSH</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;vertical-align: middle;">Tumour Markers</td><td style="border:1px solid #000;padding:5px;">Total PSA (Male) </td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;vertical-align: middle;" rowspan="3">Urine & Stool Analysis</td><td style="border:1px solid #000;padding:5px;">Urine FEME</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Urine Microalbumin / Creatinine Ratio</td></tr>' +
            '<tr><td style="border:1px solid #000;padding:5px;">Stool Occult Blood (Immuno)</td></tr>' +
            '</table></p>';
      }
      Swal.fire( {
        title: title_string,
        html: html_string,
        showCloseButton: true,
        showCancelButton: false,
        focusConfirm: false

      } )

    }
  }
}
</script>

<style scoped>
.foundation-header {
  width: 100%;
  padding-right: 80px;
  margin-bottom: 40px;
}
</style>